import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiMenu, FiX } from 'react-icons/fi';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const navItems = [
    { name: 'דף הבית', path: '/' },
    { name: 'אודות', path: '/about' },
    { name: 'טיפול משפחתי', path: '/family' },
    { name: 'טיפול זוגי', path: '/couple' },
    { name: 'טיפול אישי', path: '/personal' },
  ];

  return (
    <header 
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'
      }`}
    >
      <div className="section-container flex justify-between items-center">
        <Link to="/">
          <div className="flex items-center">
            <h1 className="text-xl md:text-2xl font-bold text-sharon-dark-green">
              שרון וייספלד
            </h1>
            <p className="text-sm md:text-base text-sharon-gray mr-2">פסיכולוגית</p>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex">
          <ul className="flex space-x-6 space-x-reverse">
            {navItems.map((item) => (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`text-lg hover:text-sharon-dark-green transition-colors duration-300 ${
                    location.pathname === item.path
                      ? 'text-sharon-dark-green font-medium'
                      : 'text-sharon-gray'
                  }`}
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button 
            onClick={toggleMenu}
            className="text-sharon-gray hover:text-sharon-dark-green transition-colors duration-300"
            aria-label={isOpen ? 'Close menu' : 'Open menu'}
          >
            {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.2 }}
          className="md:hidden bg-white w-full shadow-lg"
        >
          <nav className="py-4">
            <ul className="flex flex-col space-y-3 px-4">
              {navItems.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    onClick={() => setIsOpen(false)}
                    className={`block text-lg py-2 px-4 hover:bg-sharon-light-green hover:text-sharon-dark-green rounded transition-colors duration-300 ${
                      location.pathname === item.path
                        ? 'bg-sharon-light-green text-sharon-dark-green font-medium'
                        : 'text-sharon-gray'
                    }`}
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </motion.div>
      )}
    </header>
  );
};

export default Header;